// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/LeftSquareTwoTone";
import AntdIcon from '../components/AntdIcon';

var LeftSquareTwoTone = function LeftSquareTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftSquareTwoToneSvg
  }));
};

LeftSquareTwoTone.displayName = 'LeftSquareTwoTone';
export default React.forwardRef(LeftSquareTwoTone);